$shm_hitalama_components_history $mol_page
	versions $shm_hitalama_components_versions
	selected? \
	title \История версий
	minimal_width 480
	body /
		<= Entries $mol_list
			rows <= rows /
		^ archive_visible /$mol_view
			<= Archive_title $mol_view
				sub / \Старая история модуля
			<= Archive $mol_list
				rows <= archive_rows /
	Empty $mol_view
		sub / \Версий пока нет. Версии публикует агент после сохранения кода на GitHub.
	Entry* $mol_link
		arg <= entry_arg* *
		sub / <= entry_title* \
